import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.proudSkill.readingPeople',
    subtitle: 'pages.onboarding.proudSkill.readingPeopleSub',
    value: 'reading-people',
  },
  {
    title: 'pages.onboarding.proudSkill.technicalExpertise',
    subtitle: 'pages.onboarding.proudSkill.technicalExpertiseSub',
    value: 'technical-expertise',
  },
  {
    title: 'pages.onboarding.proudSkill.managingComplexity',
    subtitle: 'pages.onboarding.proudSkill.managingComplexitySub',
    value: 'managing-complexity',
  },
  {
    title: 'pages.onboarding.proudSkill.trustRelationships',
    subtitle: 'pages.onboarding.proudSkill.trustRelationshipsSub',
    value: 'trust-relationships',
  },
  {
    title: 'pages.onboarding.proudSkill.creativeSolving',
    subtitle: 'pages.onboarding.proudSkill.creativeSolvingSub',
    value: 'creative-solving',
  },
  {
    title: 'pages.onboarding.proudSkill.industryIntuition',
    subtitle: 'pages.onboarding.proudSkill.industryIntuitionSub',
    value: 'industry-intuition',
  },
  {
    title: 'pages.onboarding.proudSkill.leadingPeople',
    subtitle: 'pages.onboarding.proudSkill.leadingPeopleSub',
    value: 'leading-people',
  },
  {
    title: 'pages.onboarding.proudSkill.strategicThinking',
    subtitle: 'pages.onboarding.proudSkill.strategicThinkingSub',
    value: 'strategic-thinking',
  },
]

export default function ProudSkillPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.proudSkill.title"
      subtitle="pages.onboarding.proudSkill.subtitle"
    />
  )
}
